import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PreventReloadDirective } from './directives/prevent-reload.directive';
import { UnsavedChangesDirective } from './directives/unsaved-changes.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [PreventReloadDirective, UnsavedChangesDirective],
  exports: [PreventReloadDirective, UnsavedChangesDirective]
})
export class EmpathyUtilsModule {}
